export default {
  // Header
  'Search articles': 'Zoek artikelen',

  // Welcome
  'Everything about your pregnancy': 'Alles over jouw zwangerschap',
  'Who are we': 'Wie zijn wij',
  'About': `Welkom op zwangerenportaal.nl! Dit is de plek voor
    alle betrouwbare informatie over jouw zwangerschap.
    Vind hier de verzameling van alles dat je nodig hebt
    tijdens en na de komst van jouw nieuwe kindje`,

  'What do we offer': 'Wat bieden wij',

  'Information from professionals': 'Informatie van professionals',
  'Find all articles': `Vind alle artikelen omtrent jou en je baby,
    geschreven door professionals`,

  'Appointments with your midwife': 'Afspraken met je verloskundige',
  'Manage and view your appointments': `Beheer en bekijk je afspraken met
    je verloskundige praktijk`,

  'The best offers': 'De leukste aanbiedingen',
  'The best offers and benefits': `De leukste aanbiedingen en voordelen
    voor zowel moeder, baby als gezin`,

  'View and manage your files': 'Je dossiers inzien en beheren',
  'View and manage your midwife\'s records': `Bekijk en beheer je dossiers
    van de verloskundige`,

  'Blogs and vlogs': 'Blogs en vlogs',
  'Various blogs and vlogs': `Diverse blogs en vlogs van andere zwangeren
    over hun ervaringen`,

  'Login': 'Login',
  'Log in': 'Log in',
  'Create an account': 'Account aanmaken',
  'Forgot your password': 'Wachtwoord vergeten',

  // User menu
  'Log out': 'Uitloggen',
  'Profile': 'Profiel',

  // Login form
  'Username or email': 'Gebruikersnaam of email',
  'Password': 'Wachtwoord',
  'The username or password you have entered is invalid':
    'De gebruikersnaam of het wachtwoord dat u hebt ingevoerd is ongeldig',
  'Connection error': 'Verbindingsfout',

  // Register form
  'Full name': 'Volledige naam',
  'Email': 'Email',
  'Phone': 'Mobiel',
  'Repeat password': 'Wachtwoord herhalen',
  'TermsHead': 'Ik ga akkoord met de',
  'TermsLink': 'algemene voorwaarden',
  'TermsTail': 'van zwangerenportaal.nl',
  'Your data is safe with us': 'Je gegevens zijn veilig bij ons',
  'PrivacyText': `We nemen je privacy serieus en voldoen altijd aan de
    wettelijke bepalingen hiervoor. Ook nemen we maatregelen om jouw gegevens
    te beschermen. Wil je weten hoe we met je privacy omgaan? Lees dan onze`,
  'PrivacyLink': 'privacy verklaring',
  'Do you already have an account': 'Heb je al een account',
  'Lost username': 'Gebruikersnaam kwijt',
  'Request': 'Opvragen',
  'Reset password': 'Wachtwoord resetten',
  'Need help to log in': 'Hulp nodig met inloggen',
  'Click for help': 'Klik voor hulp',

  // Articles
  'Read more': 'Lees verder',
  'Recent articles': 'Recente artikelen',
  'Load more recent articles': 'Laad meer recente artikelen',
  'Popular articles': 'Populaire artikelen',
  'Load more popular articles': 'Laad meer populaire artikelen',
  'Related articles': 'Gerelateerde artikelen',
  'Load more related articles': 'Laad meer gerelateerde artikelen',
  'Saved articles': 'Opgeslagen artikelen',
  'Load more saved articles': 'Laad meer opgeslagen artikelen',
  'New from channels': 'Nieuw van kanalen die je volgt',
  'Load more articles': 'Laad meer artikelen',

  // Article
  'Previous': 'Vorige',
  'Next': 'Volgende',

  // Advertisement
  'Advertisement': 'Advertentie',

  // Article author
  'Author of this article': 'Auteur van dit artikel',
  'Subscribe': 'Abonneren',

  // Article reaction
  'Reactions': 'Reacties',
  'Header text': 'Laat weten wat je van dit artikel vindt',
  'Type something': 'Type iets',

  // User
  'You are at': 'Je bent nu in',
  'Calculated date': 'Uitgerekende datum',
  'My healthcare provider': 'Mijn zorgverlener',

  // Channels
  'Channels you follow': 'Kanalen die je volgt',
  'Subscribed': 'Geabonneerd',
  'View all channels': 'Bekijk alle kanalen',

  // Appointment
  'Appointments': 'Afspraken',
  'Description': 'Omschrijving',
  'Previous appointments': 'Voorgaande afspraken',

  // Files
  'My files': 'Mijn dossiers',
  'Provider': 'Aanbieder',
  'Registered': 'Aangemeld',
  'Integrated birth file': 'Integraal geboorte dossier',

  // File management
  'Files to be linked': 'Te koppelen dossiers',
  'Linked files': 'Gekoppelde dossiers',
  'See': 'Bekijken',
  'Allow linking': 'Koppeling toestaan',

  // File linking
  'Unlinking': 'Ontkoppelen',
  'Withdrawing permission': [`Je hebt ons toestemming gegeven om
    een koppeling te maken met het dossier van je verloskundige of
    andere behandelaar en/of om je zwangerschapsduur te gebruiken.
    Je hebt het recht om deze toestemming altijd in te trekken`, `Door
    het intrekken van de toestemming kan je de inhoud van jouw dossier niet
    meer zien. Ook kan het betekenen dat de inhoud van het zwangerenportaal
    verandert. We gebruiken deze informatie namelijk om je relevante informatie
    te tonen en tips te geven of deze te mailen rondom je zwangerschap`],
  'File unlinking': `Je staat op het punt om onderstaand dossier te
    ontkoppelen. Druk op "Akkoord" om te ontkoppelen`,
  'Back to your files': 'Terug naar dossiers',

  // Profile settings
  'Settings': 'Instellingen',
  'Change': 'Wijzig',
  'Change your password': 'Verander je wachtwoord',
  'Phone number': 'Telefoonnummer',
  'Profile visibility': 'Profiel zichtbaarheid',
  'Protected for everyone': 'Afgeschermd voor iedereen',
  'Postal code': 'Postcode',
  'Healthcare provider': 'Zorgaanbieder',
  'Weekmail': 'Weekmail',
  'Status': 'Status',
  'Back to profile': 'Terug naar profiel',
  'Change profile photo': 'Wijzig profielfoto',
  'ChangeAttributeText': `Vul je gebruikersnaam, e-mail adres of mobiel
    telefoonnummer in. Vervolgens sturen we je de wachtwoord-reset
    informatie toe`,
  'ChangeAttributePlaceholder': 'Gebruikersnaam, e-mail, telefoonnummer',
  'Drag a file here to upload': 'Sleep een bestand hierheen om te uploaden',
  'Delete account': 'Account verwijderen',
  'Delete': 'Verwijderen',

  // Footer
  'Mission': `Zwangerenportaal.nl heeft tot doel zwangeren optimaal te
    informeren over hun eigen zwangerschap.`,
  'Languages': 'Talen',
  'English': 'Engels',
  'Dutch': 'Nederlands',
  'Stay informed': 'Blijf op de hoogte',
  'Rights': 'Alle rechten voorbehouden, zwangerenportaal.nl',
  'Frequently Asked Questions': 'Veel gestelde vragen',
  'Terms and Conditions': 'Algemene voorwaarden',
  'Privacy': 'Privacy',
  'Cookie statement': 'Cookie verklaring'
};
